import React from "react";
import Lottie from "react-lottie";
import emptyIcon from "../../assests/lottie/empty.json";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: emptyIcon,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export default function NotFound() {
  return (
    <div className="items-center text-center">
      <Lottie options={defaultOptions} height={400} width={400} />

      <p className="">
          Data tidak ditemukan
      </p>
    </div>
  );
}
